import React from 'react';
import { connect } from 'react-redux';

import { getJobDetailData, getIsUnassigning } from 'redux/modules/job-detail/selectors';

import { Flexer, Spacer } from '@ontruck/orc';

import QuantityBox from 'modules/Common/QuantityBox';
import StatusInfo from 'modules/Common/Detail/StatusInfo';
import DriverInfo from 'modules/journey/detail/sections/driver-info';

import Actions from './Actions';
import JobAutomaticFlow from './JobAutomaticFlow';
import JourneyManaged from './journey-managed';

import {
  opendEditCost,
  showUnassignDecisionModal,
  assignDriver,
  copyJobDetails,
  viewValidVehicles,
  unassignJourney,
  openViewCost as openViewCostAction,
} from 'redux/modules/job-detail/effects';

import JourneyOfferStats from 'modules/journey/detail/JourneyOfferStats';

import { isLockedToAgents } from 'modules/locked-to-agents';

const JourneyInfoSection = ({
  journey,
  opendEditCost,
  openViewCost,
  showUnassignDecisionModal,
  unassigning,
  assignDriver,
  copyJobDetails,
  viewValidVehicles,
  fetching,
}) => {
  if (fetching || !journey) {
    return null;
  }
  const isCore = !journey.shipper_orders.some((shipment) => shipment.is_core === false);
  const isLHExpress = !!journey.is_lh_express;

  return (
    <Flexer.Parent alignjourneys="flex-start" fullWidth>
      <div>
        <QuantityBox
          mRight="M"
          quantityType="cost"
          allowEdit={!!journey?.driver || !isLockedToAgents(journey)}
          onClickEdit={opendEditCost}
          openViewCost={openViewCost}
          {...journey}
        />
        <JourneyManaged journeyId={journey?.id} />
      </div>
      <Flexer.Child flex="1">
        <Spacer mBottom="S">
          <StatusInfo
            driverId={journey.driver && journey.driver.id}
            status={journey.status}
            startTimeFrom={journey.start_time_from}
            isUnassigning={unassigning}
            isLocked={isLockedToAgents(journey)}
            onUnassignClick={showUnassignDecisionModal}
            isCore={isCore}
            isLHExpress={isLHExpress}
          />
        </Spacer>
        <Spacer mBottom="S">
          <JourneyOfferStats journeyId={journey.id} />
        </Spacer>
        {!!journey.driver && <DriverInfo {...journey} />}

        {!journey?.driver && !isLockedToAgents(journey) && (
          <>
            <Actions
              currency={journey.currency}
              journeyId={journey.id}
              status={journey.status}
              showStatus={true}
              assign={assignDriver}
              copyDetail={copyJobDetails}
              viewValidVehicles={viewValidVehicles}
              fleetOwner={journey.fleet_owner}
            />
          </>
        )}

        {!journey?.driver && isLockedToAgents(journey) && <JobAutomaticFlow id={journey.id} />}
      </Flexer.Child>
    </Flexer.Parent>
  );
};

export default connect(
  (state) => {
    return {
      journey: getJobDetailData(state),
      unassigning: getIsUnassigning(state),
    };
  },
  {
    opendEditCost,
    showUnassignDecisionModal,
    assignDriver,
    copyJobDetails,
    viewValidVehicles,
    unassignJourney,
    openViewCost: openViewCostAction,
  }
)(JourneyInfoSection);
